import React, { useCallback, useEffect, useState } from 'react';

import api from '../../api/api';

import { AppFooter } from '../../AppFooter';
import { HeaderHome } from '../../components/HeaderHome';

export default function Lote(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [lote, setLote] = useState(props.match.params.lote);
    const [romaneio, setRomaneio] = useState(null);

    useEffect(() => {
        setLote(props.match.params.lote);
    }, [props.match.params.lote]);

    const getLote = useCallback(async () => {
        if (!lote) return;
        try {
            const response = await api.get(`/romaneio/lote/${lote}`);
            
            setRomaneio(response.data);
        } catch (error) {
            console.error("Error fetching lote:", error);
            setErrorMessage('Ocorreu um erro ao buscar os dados. Tente novamente mais tarde.');
        }
    }, [lote]);

    useEffect(() => {
        const fetchLote = async () => {
            setIsLoading(true);  // Set loading state to true before the API call
            await getLote();
            setIsLoading(false); // Set loading state to false after the API call
        };
        fetchLote();
    }, [getLote]);

    return (
        <>
            <HeaderHome exbirEntrar={false} />
            {isLoading ? (
                <p>Carregando...</p>
            ) : errorMessage ? (
                <p style={{ color: 'red' }}>{errorMessage}</p>
            ) : romaneio && romaneio.itens?.length > 0 && romaneio.pessoa ? (
                <div className="card" style={{ pageBreakInside: 'avoid' }}>
                    <div className="card-content">
                        <div className="card-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left', marginBottom: '10px' }}>
                            <div>
                                <div className="card-row">
                                    <div className="card-column" style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '22px' }}>
                                            {romaneio.itens[0].produtoNome} - {romaneio.itens[0].produtoEmbalagem}
                                        </strong>
                                    </div>
                                    <br />
                                    <div className="card-column" style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '16px' }}>Produtor: </strong>
                                        <span style={{ fontSize: '16px' }}>{romaneio.pessoa.nome}</span>
                                    </div>
                                    <div className="card-column" style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '16px' }}>CPF/CNPJ: </strong>
                                        <span style={{ fontSize: '16px' }}>{romaneio.pessoa.cpfcnpj}</span>
                                    </div>
                                </div>

                                <div className="card-row">
                                    <div className="card-column" style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '16px' }}>Propriedade:</strong>
                                        <span style={{ fontSize: '16px' }}>
                                            {romaneio.itens[0].boletimItensId == null ? '' : romaneio.itens[0].boletimItensBoletimPropriedadeNome}
                                        </span>
                                    </div>

                                    <div className="card-column" style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '16px' }}>Município:</strong>
                                        <span style={{ fontSize: '16px' }}>
                                            {romaneio.itens[0].boletimItensId == null ? '' : romaneio.itens[0].boletimItensBoletimPropriedadeMunicipioNome}
                                        </span>
                                    </div>
                                </div>

                                <div className="card-row">
                                    <div className="card-column" style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '16px' }}>Data Comércio:</strong>
                                        <span style={{ fontSize: '16px' }}>
                                            {new Date(romaneio.dataEmissao).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}
                                        </span>
                                    </div>
                                </div>

                                <div className="card-row">
                                    <div className="card-column" style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '16px' }}>Destino:</strong>
                                        <span style={{ fontSize: '16px' }}>CEASA PATOS DE MINAS</span>
                                    </div>
                                    <div className="card-column" style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '16px' }}>Lote:</strong>
                                        <span style={{ fontSize: '16px' }}>
                                            {romaneio.itens[0].romaneioId + 'R' + romaneio.itens[0].id}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <p>Sem dados para mostrar.</p>
            )}
            <AppFooter />
        </>
    );
}
